import { ICaptionsItem } from '../../../../../types/common';
import { AppThunk } from '../../../../../store/types';
import { PlayerController } from '../../../../../effects/player/manager/playerController';
import { EShortcutsListenerContainer, setShortcutsListenerContainer } from '../../../../../effects/shortcutsListener';
import {
  findVideoPhraseById,
  getTargetCaptions,
  getVideoPhraseNoteByCaption, getVideoPhraseNoteByPhraseId
} from '../../../../../store/videos/selectors';
import { IPhraseSelectPreparatorSelectionInfo } from '../../../../../effects/phrase/utils/phrase-select-preparator';
import {
  getGroupNativeLanguage,
  getGroupTargetLanguage,
  getPhraseDetailsTabByType,
  getUserGroupById
} from '../../../../../store/models/selectors';
import { SelectionUtil } from '../../../../../../common/utils/selection-util';
import { SelectionPopupEffects } from '../../../../../effects/selectionPopupEffects';
import { PhraseDetailsActions } from '../../../../../store/phrase-details/actions';
import { EPhraseDetailsTabType } from '../../../../../store/models/types';
import { PhraseDetailsSelectors } from '../../../../../store/phrase-details/selectors';
import { AudioPlayerManager } from '../../../../../effects/audioPlayer/audioPlayerManager';
import { TargetCaptionsEffects } from '../effects/TargetCaptionsEffects';
import { PhraseListSelectors } from '../../../../../store/phrase-list/selectors';
import { PhraseDetailsEffects } from '../../../../../effects/phrase-details/phrase-details-effects';
import { CaptionsSelectionPopupActions } from '../../../../../store/captions-selection-popup/actions';
import { PhraseListActions } from '../../../../../store/phrase-list/actions';
import { PhraseEffects } from '../../../../../effects/phrase/PhraseEffects';
import { PhraseNoteEffects } from '../../../../../effects/phraseNoteEffects';
import { CaptionsSelectionPopupSelectors } from '../../../../../store/captions-selection-popup/selectors';
import { isHoverAutoPause } from '../../../../../store/general/selectors';

export class TargetAudioCaptionsEvents {

  public static onCaptionClick(
    index: number,
    caption: ICaptionsItem,
    wordIndex: number,
    ctrlKey: boolean,
    phraseId?: number,
    elementId?: string
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      if (phraseId || ctrlKey) {
        return TargetCaptionsEffects.selectCaption(index, caption, wordIndex, phraseId);
      }

      // if (phraseId) {
      //   const state = getState();
      //   const phrase = PhraseListSelectors.findPhraseById(state, phraseId);
      //   const group = getUserGroupById(state, phrase?.userGroupId);
      //   const targetLang = group && getGroupTargetLanguage(state, group) || null;
      //   if (group && targetLang) {
      //     const nativeLang = getGroupNativeLanguage(state, group);
      //     PhraseDetailsEffects.showFromSavedPhrase(targetLang, nativeLang, nativeLang, phrase.highlighted, phrase, true);
      //     dispatch(CaptionsSelectionPopupActions.setCurrentSelection({wordPhraseId: phrase.wordPhraseId, contextPhraseId: phrase.id}));
      //     dispatch(PhraseListActions.setPlayCaptionByPhraseId(phrase.id));
      //     PhraseEffects.seekPhrase(phrase);
      //     const note = getVideoPhraseNoteByPhraseId(state, phrase.id);
      //     if (note) {
      //       dispatch(PhraseListActions.setNotePopup(true));
      //     } else {
      //       PhraseNoteEffects.checkCloseNotePopup(phrase);
      //     }
      //     return;
      //   }
      // }

      const selectionInfo: IPhraseSelectPreparatorSelectionInfo = {
        text: caption.text.substring(wordIndex, wordIndex + 1),
        startCaptionIndex: index,
        endCaptionIndex: index,
        startPosition: wordIndex,
        endPosition: wordIndex + 1
      }

      const onPlay = async (): Promise<any> => {
        return AudioPlayerManager.getInstance().pause();
      }
      await TargetCaptionsEffects.runSelectText(window.getSelection(), selectionInfo, elementId, false, true, onPlay);
    }
  }

  public static onCaptionDblClick(index: number, caption: ICaptionsItem) : AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      AudioPlayerManager.getInstance().play(caption.startTime);
    }
  };

  public static onCaptionPlay(caption: ICaptionsItem, isPause?: boolean): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (isPause) {
        AudioPlayerManager.getInstance().pause();
      } else {
        AudioPlayerManager.getInstance().play(caption.startTime);
      }
      setShortcutsListenerContainer(EShortcutsListenerContainer.CAPTIONS);
    }
  }

  public static onCaptionMouseDown(): AppThunk {
    return (
      dispatch,
      getState
    ) => {

      if (AudioPlayerManager.getInstance().isPlayerActive()) {
        AudioPlayerManager.getInstance().pause();
      }
    }
  }

  public static onMouseLeave(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (!isHoverAutoPause(getState())) return;
      PlayerController.getInstance().mouseLeave();
    }
  }

  public static onMouseEnter(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (!isHoverAutoPause(getState())) return;
      PlayerController.getInstance().mouseEnter();
    }
  }

  public static onSelectText(
    selection: Selection,
    elementId: string,
    isSelectPopup?: boolean,
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {

      const onPlay = async (): Promise<any> => {
        return AudioPlayerManager.getInstance().pause();
      }
      await TargetCaptionsEffects.runSelectText(selection, null, elementId, isSelectPopup, true, onPlay);

      /*

      const state = getState();
    //  dispatch(CaptionsSelectionPopupActions.setShow(true));

      const targetLanguage = getSelectedTargetCaption(state);
      const nativeLanguage = getSelectedNativeCaption(state);

      const wordSelectPhrases = findVideoPhrasesByType(state, EVocabularyPhraseType.WORD_SELECTED);
      const contextPhrases = findVideoPhrasesByType(state, EVocabularyPhraseType.WORD_AND_CONTEXT_SELECTED);
      const useCheckSpanWords = !LangUtil.isHieroglyphLang(targetLanguage?.code || '');
      const selResult = new PhraseSelectPreparator(selection, null, getTargetCaptions(state), wordSelectPhrases, contextPhrases, elementId, useCheckSpanWords).execute();

      batch(() => {
        dispatch(CaptionsSelectionPopupActions.setShow(true));
        dispatch(CaptionsSelectionPopupActions.setSelection(selection));
        dispatch(CaptionsSelectionPopupActions.setSelectResult(selResult));
        dispatch(setCurrentVideoClickedCaptionIndex(-1));
        dispatch(PhraseListActions.setPlayCaptionByPhraseId(0));
        dispatch(PhraseListActions.setCurrentPhraseId(0));
        dispatch(PhraseListActions.setPlayPhraseId(0));
        dispatch(PhraseDetailsActions.disActivate());
      })

      if (targetLanguage && selResult && selResult.text) {
        if (selResult.text) {
          const activeGroupNativeLang = getActiveGroupNativeLanguage(state);
          if (selResult.insideWordActiveId) {
            PhraseDetailsEffects.showFromPhrase(targetLanguage, nativeLanguage, activeGroupNativeLang,
              selResult.insideWordActiveId, selResult.text);
          } else {
            PhraseDetailsEffects.showFromSelectText(targetLanguage, nativeLanguage, activeGroupNativeLang, selResult);
          }

          if (!getAuthUser(state)?.teacherMode) {
            const group = getActiveUserGroup(state);
            let phrase;
            if (selResult.insideWordPhrases && selResult.insideWordPhrases.length) {
              phrase = selResult.insideWordPhrases.find(p => p.highlighted === selResult.text);
            }
            if (!phrase && group?.type !== EUserGroupType.PREVIEW)
              PhraseEffects.runSavePreviewPhrase(selResult);
          }

          await AudioPlayerManager.getInstance().pause();
        }
      }

      if (selResult && isSelectPopup) {
        dispatch(TextSelectionPopupEvents.onPreviewPhrase(selResult));
      }*/
    }
  }

  public static onDismissSelectText(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (document.body.classList.contains('onboarding-active')) return;

      SelectionUtil.removeWindowSelection();
      SelectionPopupEffects.dismissSelectText();
    }
  }

  public static onChangeActiveIndex(index: number) : AppThunk {
    return (
      dispatch,
      getState
    ) => {
      const state = getState();
      const captions = getTargetCaptions(state);
      if (index >= 0 && index < captions.length) {
   //     dispatch(PhraseDetailsActions.setPhraseId(0));
        const note = getVideoPhraseNoteByCaption(state, captions[index]);
        if (note) {
          const noteTab = getPhraseDetailsTabByType(state, EPhraseDetailsTabType.NOTES);
          if (noteTab) {
            dispatch(PhraseDetailsActions.setActiveTab(noteTab));
            dispatch(PhraseDetailsActions.setNotePreviewMode(true));
            if (note.pause && PlayerController.getInstance().isCaptionsPlayMode()) {
              PlayerController.getInstance().pause();
              dispatch(PhraseDetailsActions.setPhraseId(note.phraseId));
            }
          }
        } else {
          if (PhraseDetailsSelectors.getNotePreviewMode(state)) {
            const translateTab = getPhraseDetailsTabByType(state, EPhraseDetailsTabType.TRANSLATION);
            if (translateTab) {
              dispatch(PhraseDetailsActions.setActiveTab(translateTab));
            }
            dispatch(PhraseDetailsActions.setNotePreviewMode(false));
          }
        }
      }
    }
  }

  public static onGetPhraseTitle(phraseId: number) : AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (phraseId) {
        return findVideoPhraseById(getState(), phraseId)?.translated || '';
        /*const contextPhrase = findVideoPhraseById(getState(), phraseId);
        if (contextPhrase?.wordPhraseId) {
          const phrase = findVideoPhraseById(getState(), contextPhrase?.wordPhraseId);
          return phrase?.translated || '';
        }*/
      }
      return '';
    }
  }


}
